import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';

@Component({
  selector: 'fury-edit-email-template',
  templateUrl: './edit-email-template.component.html',
  styleUrls: ['./edit-email-template.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class EditEmailTemplateComponent implements OnInit {

  emailTemplateForm!: FormGroup;
  bannerImage: any
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: true,
    indent: false,
    breakBeforeOpen: false,
    breakAfterOpen: false,
    breakBeforeClose: false,
    breakAfterClose: false,
    autoParagraph: false,
    enterMode: CKEDITOR.ENTER_BR
  };
  constructor(
    private apiService: ApiService,
    private location: Location
  ) {
    this.formInit();
    this.getEmailTemplateData();
   }

  ngOnInit(): void {
  }
  formInit(){
    this.emailTemplateForm = new FormGroup({
      image: new FormControl(''),
      imageLink: new FormControl('', [Validators.required, Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=%.]+$/)]),
      aboveImageText: new FormControl('', [Validators.required]),
      belowImageText: new FormControl('', [Validators.required]),
      bottomText: new FormControl('', [Validators.required]),
      senderName: new FormControl('', [Validators.required]),
      sentEmailFrom: new FormControl('', [Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]),
      replyToAddress: new FormControl('', [Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]),
    })
  };

  getEmailTemplateData(){
    this.apiService.get('admin/email-template-content/get-email-template-content').subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.bannerImage = res.body?.emailTemplateContent?.image;
        this.emailTemplateForm.patchValue({
          imageLink: res.body?.emailTemplateContent?.imageLink,
          aboveImageText: JSON.parse(res.body?.emailTemplateContent?.aboveImageText),
          belowImageText: JSON.parse(res.body?.emailTemplateContent?.belowImageText),
          bottomText: JSON.parse( res.body?.emailTemplateContent?.bottomText),
          senderName : res?.body?.emailTemplateContent?.senderName,
          sentEmailFrom  : res?.body?.emailTemplateContent?.sentEmailFrom,
          replyToAddress  : res?.body?.emailTemplateContent?.replyToAddress,
        });
      }
    })
  };

  onImageUpload(event: any) {
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file: File;
      file = event.target.files[0];
      this.emailTemplateForm.patchValue({ image: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiService.alert(ErrorText.ImageRestriction, 'error');
    }
  };
  
  updateTemplate(){ 
    if(this.emailTemplateForm.valid){
      if(this.bannerImage){
        const data = new FormData();
      data.append('aboveImageText', JSON.stringify(this.emailTemplateForm.value?.aboveImageText));
      data.append('belowImageText', JSON.stringify( this.emailTemplateForm.value?.belowImageText));
      data.append('bottomText', JSON.stringify(this.emailTemplateForm.value?.bottomText));
      data.append('imageLink', this.emailTemplateForm.value?.imageLink);
      data.append('senderName', this.emailTemplateForm.value?.senderName);
      data.append('sentEmailFrom', this.emailTemplateForm.value?.sentEmailFrom);
      data.append('replyToAddress', this.emailTemplateForm.value?.replyToAddress);
      if(this.emailTemplateForm.value?.image){
        data.append('image', this.emailTemplateForm.value?.image);
      };

        this.apiService.postMultiData(`admin/email-template-content/update-email-template-content`, data).subscribe((res:any)=>{
          if (res.body) {
            this.apiService.alert(res.body?.message, ErrorType.Success);
            this.location.back();
          } else { this.apiService.alert(res.body?.message, ErrorType.Warning); }
        }, err =>{
          this.apiService.alert(err?.message, ErrorType.Error);
        })
      } else {
        this.apiService.alert('Please Upload Email Template Image', ErrorType.Error);
      }    
    } else {
      this.emailTemplateForm.markAllAsTouched();
    }
  };

}
